import React, { useEffect, useState, useRef } from 'react'

import Tone from  'tone'

import walking60bars from './assets/audio/walking60.mp3'
import strings45bars from './assets/audio/strings48.mp3'
import stepRhythm41bars from './assets/audio/rhythm43.mp3'
import voices35bars from './assets/audio/voices41.mp3'
import {map_range} from './HandyMaths'


export const LALAudioEngine = (props: {
  onLoad: () => {},
  onLevel: (n) => {}
}) => {

  const [engineLoaded, setEngineLoaded] = useState(false);

  const meter = useRef(null)
  const delay = useRef(null)
  const p = useRef(props)
  
  useEffect(() => {

    console.log("audio engine")

    delay.current = new Tone.PingPongDelay(0.19, 0.65).toMaster()
    
    delay.current.set({
      "delayTime": 0.084 ,
      "maxDelayTime": 1.0
    })

    const player = new Tone.Player(walking60bars, (p) => {
      player.loopStart = 0.0
      player.loopEnd = 180.0 + 12.0
      player.playbackRate = 1
      player.loop = true
      player.volume.value = -5 //db


      const player2 = new Tone.Player(strings45bars, (p) => {
        player2.loopStart = 0.0
        player2.loopEnd = 120.0 + 34.0
        player2.playbackRate = 1
        player2.loop = true
        player2.volume.value = -5 //db

        
        const player3 = new Tone.Player(voices35bars, (p) => {
          player3.loopStart = 0.0
          player3.loopEnd = 120.0 + 11.0
          player3.playbackRate = 1
          player3.loop = true
          player3.volume.value = -5 //db

          const player4 = new Tone.Player(stepRhythm41bars, (p) => {
            player4.loopStart = 0.0
            player4.loopEnd = 120.0 + 18.0
            player4.playbackRate = 1.0  
            player4.loop = true
            player4.volume.value = -5 //db

            player.start(Tone.now() , 0.0)
            player2.start(Tone.now() , 0.0)
            player3.start(Tone.now() , 0.0)
            player4.start(Tone.now() , 0.0)
        
            setEngineLoaded(true)

          }).toMaster()

        }).toMaster()

      }).connect(delay.current)
      
    }).toMaster()


  }, [])

  useEffect(() => {
    if(engineLoaded){
      p.current.onLoad()
      // const clock = new Tone.Clock(function(time){
      //   p.current.onLevel(meter.current.getLevel() )
      // }, 60)

      // clock.start()
    }
  },[ engineLoaded, p])



  useEffect(() => {
    // console.log(props, meter.current.getLevel())

    let normX = props.activePosition.x / window.innerWidth
    let normY = props.activePosition.y / window.innerHeight
    // let normX = this.props.props.activePosition.x / window.innerWidth
    // let normY = this.props.props.activePosition.y / window.innerHeight

    delay.current.delayTime.linearRampTo(map_range(normX, 0.0, 1.0, 0.1, 0.113), 0.1)
    delay.current.feedback.linearRampTo(map_range(normY, 0.0, 1.0, 0.1, 0.98), 0.2)
    // this.delay.delayTime.linearRampTo(map_range(normX, 0.0, 1.0, 0.1, 0.113), 0.1)
    // this.delay.feedback.linearRampTo(map_range(normY, 0.0, 1.0, 0.1, 0.98), 0.2)

    Tone.Transport.bpm.value = map_range(normX, 0.0, 1.0, 60, 4000)
    // Tone.Transport.bpm.value = map_range(normX, 0.0, 1.0, 60, 4000)

  },[props, meter, delay])

  return (
      <div>
      </div>
  )
}

export default LALAudioEngine;